export { default } from './use-get-partners';
export { default as GetPartnersAPIHandlers } from './use-get-partners.mock';
